module.exports = __webpack_public_path__ + "assets/img/walmart@2x.0afe1156.png";